import styled from '@emotion/styled'

import { Spacing } from '../../../../enums/spacing'

interface TableFilteringWrapperProps {
  withSpacing: boolean
}

export const TableFilteringWrapper = styled.div<TableFilteringWrapperProps>`
  margin-right: ${({ withSpacing }) => (withSpacing ? Spacing.S16 : 0)};
`
